import React from "react";
import css from "./FileNavigator.module.css";
import {TabNavigator} from "react-vritra";
import {FileView} from "Components";
import {js0,hash0} from "Assets";


export default function FileNavigator(props){
    const {files,preview}=props;
    return (
        <div className={`${css.filenavigator} ${props.className||""}`} style={props.style}>
            {files.length>1?
                <TabNavigator
                    className={css.tabnavigator}
                    headerClassName={css.header}
                    containerClassName={css.container}
                    tabTextColor={hasLightTheme?backgroundColor:textColor}
                    tintColor={mainColor}
                    tabs={files?.map(file=>{
                        const {name}=file;
                        const extension=name.substring(name.lastIndexOf(".")+1);
                        return {
                            id:name,
                            label:name,
                            icon:statics.icon[extension],
                            renderContent:()=><FileView className={css.fileview} content={file.content} editable="true"/>
                        }
                    })}
                />:
                <FileView 
                    className={css.tabnavigator+" "+css.container} 
                    content={files[0].content} 
                />
            }
            {preview&&(typeof(preview)==="function"?
                <div 
                    className={`${css.preview} ${props.previewClassName||""}`} 
                    ref={(element)=>{
                        if(element){
                            element.innerHTML="";
                            preview({parent:element});
                        };
                    }}
                />:
                <img alt="preview" className={css.preview} src={preview}/>
            )}
        </div>

    )
}

const statics={
    icon:{
        js:js0("#e5e84a"),
        css:hash0("#2d93e1"),
    },
}
